import { checkEnvironment } from '@saviynt/common';

const getDeleteSshKeyApiUrl = (slot) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/ssh-keys/${slot}`;
};

export default getDeleteSshKeyApiUrl;
